module.exports = __webpack_public_path__ + "img/flag_roulette_anime.645ec027.gif";